import { ACCOUNT } from 'actionTypes';
import actionsFactory from 'utils/redux/baseEntitiesFactory/actions';
import reducerFactory from 'utils/redux/baseEntitiesFactory/reducer';
import sagasFactory from 'utils/redux/baseEntitiesFactory/sagas';
import thunkFactory from 'utils/redux/baseEntitiesFactory/thunk';

// ACTIONS
const rawActions = actionsFactory(ACCOUNT);
const actions = { ...rawActions, ...thunkFactory(ACCOUNT, '/accounts/') };
export { actions };

// REDUCER
const initialState = {
  ids: [],
  models: {},
  loaded: false,
  loading: false,
  errorMessage: '',
  submitting: false
};

const options = {
  orderBy: {
    what: ['account_nome'],
    how: ['asc']
  }
};

export default reducerFactory(ACCOUNT, initialState, options);

// SAGAS
const sagas = sagasFactory(ACCOUNT, '/accounts/');
export { sagas };
